import { render, staticRenderFns } from "./AssessList.vue?vue&type=template&id=147cd833&"
import script from "./AssessList.vue?vue&type=script&lang=js&"
export * from "./AssessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports